import CollectionsObject from "components/Collections";
import ElementsObject from "components/Elements";
import ObjectsObject from "components/Objects";
import PartsObject from "components/Parts";

import TypesObject from "constants/Types";

export let Collections = CollectionsObject;
export let Elements = ElementsObject;
export let Objects = ObjectsObject;
export let Parts = PartsObject;

export let Types = TypesObject;

const Components =  {
	Collections: Collections,
	Elements: Elements,
	Parts: Parts,
	Objects: Objects,
	Types: Types,
};

export default Components;
